import { Box, BoxProps, Image, ImageProps, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'
const moderndevices = require('../../assets/images/moderndevices.png')

export const ModernSmartDevice = () => {
  const { textSize, headerSize } = useFontSize()
  const viewPortWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewPortWidth)
  const styles = style(isMob)
  const resPadding = usePadding()
  return (
    <Box {...styles.mainContainer}>
      <Box {...styles.leftContainer}>
        <Box {...styles.leftBox}>
          <Text
            title={staticStrings.modernDeviceTitle}
            fontFamily={'jiotype-black'}
            fontSize={headerSize}
            color={'BLACK_21'}
            lineHeight={isMob ? 36 : 72}
          />
          <Spacer size={16} />
          <Box paddingRight={isMob ? resPadding : 80}>
            <Text
              title={staticStrings.modernDeviceSubTitle}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              color={'BLACK_21'}
              opacity={0.9}
              lineHeight={isMob ? 20 : 28}
            />
          </Box>
        </Box>
      </Box>
      <Spacer direction={'horizontal'} size={120} />
      <Box {...styles.rightContainer}>
        <Image {...styles.imageBox} source={moderndevices} />
      </Box>
    </Box>
  )
}

const style = (isMob: boolean) => {
  return {
    mainContainer: {
      justify: 'space-between',
      marginTop: isMob ? 120 : undefined,
      flexDirection: isMob ? 'column-reverse' : 'row',
    } as BoxProps,
    leftContainer: {
      f: isMob ? undefined : 0.5,
    } as BoxProps,
    rightContainer: {
      f: isMob ? undefined : 0.5,
    } as BoxProps,
    leftBox: {
      pt: isMob ? 24 : 64,
    } as BoxProps,
    imageBox: {
      width: '100%',
      height: isMob ? 250 : 600,
      resizeMode: 'contain',
    } as ImageProps,
  }
}
